import { useCallback, useEffect, useRef } from 'react';

import { Progress } from '@atom/mui';
import { UserDetail } from '@atom/types/user';

import EditTaskUserTile from './EditTaskUserTile';

import classes from './userTile.module.css';

interface Props {
  users: UserDetail[];
  total: number;
  loading: boolean;
  handlePageScroll: () => void;
}

const EditTaskUsers = ({ users, total, loading, handlePageScroll }: Props) => {
  const scrollContainerRef = useRef<any>(null);

  const handleScroll = useCallback(() => {
    const elem = scrollContainerRef?.current;
    const isBottom =
      elem?.scrollTop + elem?.clientHeight + 0.5 >= elem?.scrollHeight;
    if (isBottom && users.length < total && !loading) {
      handlePageScroll();
    }
  }, [scrollContainerRef.current, total, users, handlePageScroll]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef?.current?.addEventListener('scroll', handleScroll);
      return () =>
        scrollContainerRef?.current?.removeEventListener(
          'scroll',
          handleScroll,
        );
    }
    return () => {};
  }, [handleScroll]);

  return (
    <>
      <div ref={scrollContainerRef} className={classes.usersList}>
        {users.map(user => (
          <EditTaskUserTile user={user} />
        ))}
      </div>
      {loading && <Progress />}
    </>
  );
};

export default EditTaskUsers;
